import { autoinject, transient } from "aurelia-dependency-injection";
import { I18N } from "aurelia-i18n";
import * as moment from "moment";
import { LookupAuditParameterModel } from "../../../../models/lookups/lookup.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService } from "../../../../services/basics/notification-client.service";
import { QueriesClientService } from "../../../../services/queries/queries-client.services";
import { BaseHistoryTrail } from "../../common/base-history-trail";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
@transient()
export class SelectedLookupAuditDialog extends BaseHistoryTrail<LookupAuditParameterModel> {

    public audits: any[] = [];
    public actionFilter = "";

    constructor(private dialogClient: DialogClientService, protected queriesClientService: QueriesClientService,
        notificationClientService: NotificationClientService, i18N: I18N, configService: ConfigService) {
        super(configService, notificationClientService, i18N);
     }

    protected onActivated() {
        this.refreshData();
    }

    public getUrl(){
        return  `/odata/Audits/?$filter=(entityTypeId eq ${this.item.entityType} and action eq '${this.actionFilter}')?$orderby=timestamp desc`;
    }

    activate(params:{action:string}){
        this.actionFilter = params.action;
        super.activate(params);
    }

    public refreshData() {
        this.queriesClientService.getData(this.getUrl()).then(x => {
            this.audits = x.value;
        });
    }


    getFormattedDate(date) {
        return moment(date).format(this.configService.config.common.defaultDateTimeFormat);
    }

    close() {
        this.dialogClient.hide();
    }

}